import React from 'react';

export const QCPageCards = ({
	onClickFunction,
	dataTTID,
	additionalStyle,
	cardTitle,
	cardText,
	cardIcon,
    disabled
}) => {

	return (
		<button
			onClick={ onClickFunction}
			className="QCTypeButtons"
			data-tooltip-id={dataTTID}
            disabled={disabled}
		>
			<div
				className="card QCTypeButtonsBtn"
				style={additionalStyle}
			>
				<div className="card-body d-flex flex-column justify-content-center">
					<h5 className="card-title ">
						{cardTitle}
						{cardIcon}
					</h5>
					<p className="card-text">{cardText}</p>
				</div>
			</div>
		</button>
	);
};
